// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import Router from 'vue-router';
import axios from 'axios';
// 引入axios
import Video from 'video.js'
import 'video.js/dist/video-js.css'
import 'babel-polyfill'
Vue.prototype.$video = Video
export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        })
    })
}
Vue.prototype.$get = get;
Vue.prototype.$axios = axios;
import './assets/iconfont/iconfont.css';
import './assets/iconfont/iconfont.js';

Vue.config.productionTip = false;
Vue.use(Router)
Vue.use(ElementUI)
    /* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js